import mdAxios from "core/common/config/axios-config";
import {BankTransaction} from "accounting/accountingDomain";


class AccountingService {

  readBankTransaction(bankTransactionId: number): Promise<BankTransaction> {
    return mdAxios.get('/bank-transaction/' + bankTransactionId)
      .then(response => new BankTransaction(response.data));
  }


}


export default new AccountingService();



// WEBPACK FOOTER //
// ./src/accounting/service/accountingService.ts